<ng-container *ngIf="mode === 'cell'">
  <div class="saldo" [ngClass]="view.level" data-testid="account-balance-cell">
    <ng-container *ngIf="view.kind === 'wallet'; else creditsCell">
      <ng-container *ngIf="view.level === 'unavailable'; else walletCellOk">
        <span class="sv-main"><i class="fa fa-exclamation-triangle"></i> Saldo indisponível</span>
        <span class="sub">A carteira não respondeu agora</span>
      </ng-container>
      <ng-template #walletCellOk>
        <span class="sv-main">
          {{ formatBRL(walletAvailable) }}
          <span class="flag-low zero" *ngIf="view.level === 'zero'"><i class="fa fa-exclamation-circle"></i> sem saldo</span>
          <span class="flag-low" *ngIf="view.level === 'low'"><i class="fa fa-exclamation-circle"></i> baixo</span>
        </span>
        <span class="sub">
          ≈ <b>{{ formatEquivalent(view.sms?.available) }}</b> SMS
          <ng-container *ngIf="view.call">· ≈ <b>{{ formatEquivalent(view.call.available) }}</b> ligações</ng-container>
        </span>
      </ng-template>
    </ng-container>

    <ng-template #creditsCell>
      <ng-container *ngIf="view.level === 'unavailable'; else creditsCellOk">
        <span class="sv-main"><i class="fa fa-exclamation-triangle"></i> Saldo indisponível</span>
        <span class="sub">Não deu para ler o saldo desta conta agora</span>
      </ng-container>
    </ng-template>

    <ng-template #creditsCellOk>
      <span class="sv-main">
        {{ formatEquivalent(view.sms?.available) }} <small>créditos SMS</small>
        <span class="flag-low zero" *ngIf="view.level === 'zero'"><i class="fa fa-exclamation-circle"></i> sem saldo</span>
        <span class="flag-low" *ngIf="view.level === 'low'"><i class="fa fa-exclamation-circle"></i> baixo</span>
      </span>
      <span class="sub">
        <ng-container *ngIf="view.call">
          <b>{{ formatEquivalent(view.call.available) }}</b> créditos de ligação ·
        </ng-container>
        <ng-container *ngIf="view.wallet">
          <ng-container *ngIf="walletAvailable !== null; else walletCellUnavail">
            carteira {{ formatBRL(walletAvailable) }} (WhatsApp/IA)
          </ng-container>
          <ng-template #walletCellUnavail>carteira indisponível</ng-template>
        </ng-container>
      </span>
    </ng-template>
  </div>
</ng-container>

<ng-container *ngIf="mode === 'block'">
  <div class="kpis" data-testid="account-balance-block">
    <ng-container *ngIf="view.kind === 'wallet'; else creditsBlock">
      <div
        class="kpi"
        [class.danger]="view.level === 'zero'"
        [class.warn]="view.level === 'low'"
        [class.ok]="view.level === 'ok'"
        data-testid="balance-wallet-available"
      >
        <h4><i class="fa fa-money ic"></i> Saldo da carteira</h4>
        <ng-container *ngIf="view.level === 'unavailable'; else walletBlockOk">
          <b class="small-value"><i class="fa fa-exclamation-triangle"></i> Saldo indisponível</b>
          <small>A carteira não respondeu agora. Não é saldo zero.</small>
        </ng-container>
        <ng-template #walletBlockOk>
          <b>{{ formatBRL(walletAvailable) }}</b>
          <small *ngIf="view.level === 'low'"><i class="fa fa-exclamation-circle"></i> saldo baixo</small>
          <small *ngIf="view.level === 'zero'"><i class="fa fa-exclamation-circle"></i> sem saldo</small>
        </ng-template>
      </div>

      <div class="kpi" [class.cool]="view.level !== 'unavailable'" data-testid="balance-sms-equivalent">
        <h4><i class="fa fa-commenting-o ic"></i> SMS</h4>
        <b>{{ view.sms?.available === null || view.sms?.available === undefined ? '—' : ('≈ ' + formatEquivalent(view.sms?.available)) }}</b>
      </div>

      <div class="kpi" [class.cool]="view.level !== 'unavailable'" *ngIf="view.call" data-testid="balance-call-equivalent">
        <h4><i class="fa fa-phone ic"></i> Ligação</h4>
        <b>{{ view.call?.available === null || view.call?.available === undefined ? '—' : ('≈ ' + formatEquivalent(view.call?.available)) }}</b>
      </div>

      <div class="kpi violet" data-testid="balance-whatsapp-ai">
        <h4><i class="fa fa-whatsapp ic"></i> WhatsApp / IA</h4>
        <b class="small-value">Pela carteira</b>
        <small>mesmo saldo em R$</small>
      </div>
    </ng-container>

    <ng-template #creditsBlock>
      <div
        class="kpi"
        [class.danger]="view.level === 'zero'"
        [class.warn]="view.level === 'low'"
        [class.ok]="view.level === 'ok'"
        data-testid="balance-sms-credits"
      >
        <h4><i class="fa fa-commenting-o ic"></i> Créditos de SMS</h4>
        <ng-container *ngIf="view.level === 'unavailable'; else smsCreditsOk">
          <b class="small-value"><i class="fa fa-exclamation-triangle"></i> Saldo indisponível</b>
          <small>Não deu para ler o saldo agora. Não é saldo zero.</small>
        </ng-container>
        <ng-template #smsCreditsOk>
          <b>{{ formatEquivalent(view.sms?.available) }}</b>
          <small *ngIf="view.sms?.contracted !== undefined">{{ view.sms?.sent | numberFormat }} enviados de {{ view.sms?.contracted | numberFormat }}</small>
        </ng-template>
      </div>

      <div class="kpi" *ngIf="view.call" data-testid="balance-call-credits">
        <h4><i class="fa fa-phone ic"></i> Ligação</h4>
        <b>{{ formatEquivalent(view.call?.available) }}</b>
        <small>créditos do pacote</small>
      </div>

      <div class="kpi cool" data-testid="balance-whatsapp-wallet">
        <h4><i class="fa fa-wallet ic"></i> Carteira · WhatsApp e IA</h4>
        <ng-container *ngIf="view.wallet; else noWalletChannel">
          <ng-container *ngIf="walletAvailable !== null; else creditsBlockUnavail">
            <b>{{ formatBRL(walletAvailable) }}</b>
            <small>WhatsApp e IA saem só daqui</small>
          </ng-container>
          <ng-template #creditsBlockUnavail>
            <b class="small-value"><i class="fa fa-exclamation-triangle"></i> Saldo indisponível</b>
            <small>não é zero — a carteira não respondeu</small>
          </ng-template>
        </ng-container>
        <ng-template #noWalletChannel>
          <b class="small-value">—</b>
          <small>WhatsApp/IA não estão na carteira</small>
        </ng-template>
      </div>
    </ng-template>
  </div>
</ng-container>
